import React from 'react';
import { Link } from 'react-router-dom'; 
import { useAuthContext } from '../../hooks/useAuthContext.js';



const Navbar = () => {
  const {user, signOut} = useAuthContext()
  const handleClick = () => {
    window.location.href = "/";
  }

  const handleSignOut = async() => {
    const error = await signOut()
    if (error) {
      console.log(error.message)
      return
    }else{
      window.location.href = "/"
    }
     
  }

  const handleSignIn = () => {
    window.location.href = "/Login";
  }

  const handleRegister = () => {
     window.location.href = "/signup";
  }

  return (
   
        <nav style={navbarStyle}>
            <div onClick={handleClick}>
                <img
                  src="C:\Users\ShelbyVaughn\Documents\Dibbs_Scraper\dailydibbs_logo.png"
                  style={logoStyle}
                  alt="Company Logo"
                
                />
            </div>
           
        <ul style={navListStyle}>
            <li style={navItemStyle}>
              <Link to="/" style={linkStyle}>Home</Link>
            </li>
            {
                <li style={navItemStyle}>
                  <Link to="/Forecast" style={linkStyle}>Forecast</Link>
                </li>
            }

            {
              user  &&
                <li style={navItemStyle}>
                  <Link to="/NSNSearch" style={linkStyle}>NSN Lookup</Link>
                </li>
            }

            {
              user && 
                <li style={navItemStyle}>
                  <Link to="/cageSearch" style={linkStyle}>Cage Code Search</Link>
                </li>
            }

          <li style={navItemStyle}>
              <Link to="/Contact" style={linkStyle}>Contact</Link>
            </li>


            {
              user && 
                <li style={navItemStyle}>
                  <Link to="/Account" style={linkStyle}>Account</Link>
                </li>
            }

            
        </ul>
          {user && ( 
              <div>
              <span>{user.email}</span>
              <button onClick={handleSignOut} style={signinStyle} >Log out</button>
              
            </div>
          )}

          {!user && (
            <div style={loginDivStyle}>
              <button onClick={handleRegister} style={registerStyle}>Register</button>
              <button onClick={handleSignIn} style={signinStyle}>Sign In</button>
            </div>
          )}
            

        </nav>
  
  );
};

const loginDivStyle = {
  display: 'grid',
  gap: '1rem',
  paddingLeft: '1rem',
  paddingRight: '1rem'
}

const signinStyle = {
  fontSize: '14px',
  height: '35px',
  width: '75px',
  lineHeight: '140%',
  fontFamily: 'Inter',
  backgroundColor: '#A3C8DB',
  borderRadius: '5px',
  color:'black',
  border: '2px solid #A3C8DB',
  cursor: 'pointer'
}

const registerStyle = {
  fontSize: '14px',
  height: '35px',
  width: '75px',
  lineHeight: '140%',
  fontFamily: 'Inter',
  backgroundColor: '#213575',
  borderRadius: '5px',
  color:'white',
  border: '2px solid #213575',
  cursor: 'pointer'
}

const navbarStyle = {
  backgroundColor: '#FFFFFF',
  padding: '1rem',
  paddingTop: '2rem',
  borderBottom: '1px solid gainsboro'
};

const logoStyle = {
    width: '75px', // Adjust the logo size here
    height: 'auto',
    position: 'relative',
    marginRight: '100px',
    cursor: 'pointer'
  };

 
const navListStyle = {
  listStyleType: 'none',
  marginLeft: 'auto',
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
};

const navItemStyle = {
  margin: '0 15px',
};

const linkStyle = {
  color: 'black',
  textDecoration: 'none',
  fontSize: '16px',
};

export default Navbar;
